@if (props.dropdown && props.dropdown.split) {
  <div class="btn-group">
    <button class="btn btn-{{ props.btnClass }}" (click)="onClick($event)">
      <i class="{{ props.iconClass }}"></i> {{ props.text }}
    </button>
    <div class="btn-group" ngbDropdown>
      <button class="btn btn-{{ props.btnClass }} dropdown-toggle-split" ngbDropdownToggle></button>
      <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
        @for (dropdown of props.dropdown.items; track dropdown.text) {
          <button class="btn" (click)="onDropdownClick(dropdown, $event)" ngbDropdownItem>
            <i class="{{ dropdown.iconClass }}"></i> {{ dropdown.text }}
          </button>
        }
      </div>
    </div>
  </div>
}

@if (props.dropdown && !props.dropdown.split) {
  <div class="d-inline-block" ngbDropdown #dropdownButton="ngbDropdown">
    <button class="btn btn-{{ props.btnClass }}" ngbDropdownAnchor (click)="dropdownButton.open()">
      <i class="{{ props.iconClass }}"></i> {{ props.text }}
    </button>
    <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
      @for (dropdown of props.dropdown.items; track dropdown.text) {
        <button class="btn" (click)="dropdown.onClick($event)" ngbDropdownItem>
          <i class="{{ dropdown.iconClass }}"></i> {{ dropdown.text }}
        </button>
      }
    </div>
  </div>
}

@if (!props.dropdown) {
  <button class="btn btn-{{ props.btnClass }}" [type]="props.type" [formlyAttributes]="field" (click)="onClick($event)">
    @if (props.iconClass) {
      <i [class]="props.iconClass"></i>
    }
    {{ props.text }}
    @if (props.iconClassRight) {
      <i [class]="props.iconClassRight"></i>
    }
  </button>
}
